export const xs = {
  content : {
    width: "100%",
    top: "32px",
    left: "0",
    right: "0",
    bottom: "0",
    border: "none",
    borderRadius: "0px",
    background: "white",
    padding: 0,
  }
};
export const sm = {
  content : {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    height: "768px",
    width: "320px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "0px",
    background: "white",
    padding: 0,
  }
};

export const md = {
  content : {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    height: "512px",
    width: "320px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "0px",
    background: "white",
    padding: 0,
  }
};